// Add an explanatory component to the vendor dashboard
// filepath: /Users/abioyebankole/fashion-app/frontend/src/components/Vendor/VendorStatusExplainer.jsx
const VendorStatusExplainer = () => {
  return (
    <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
      <div className="flex">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2h-1V9z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="ml-3">
          <p className="text-sm text-blue-700">
            <strong>Status Explanation:</strong> Orders marked as "PROCESSING" require action from you as the vendor. 
            Orders will update to "SHIPPED" once you've marked them as dispatched.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VendorStatusExplainer;